
import { MdMsgBox } from 'mdesign-plus';

export const useTipMsgBox = ({ message, confirmButtonText = 'Yes', cancelButtonText = 'No', style="" }, callback) => {
    MdMsgBox({
        message,
        title: '',
        customClass: 'md-messagebox confirm csr-messagebox ' + style,
        showCancelButton: true,
        confirmButtonText: confirmButtonText,
        cancelButtonText: cancelButtonText,
        showClose: true,
        center: true,
        closeOnClickModal: false,
        lockScroll: false,
        iconClass: 'csr-message-icon-info',
    }).then(() => {
        callback()
    }).catch(() => {

    });
}